/* Vastro Print - Bulk pricing popup for Horizon collection cards (fixed 100+ tier) */
(() => {
  const popup = document.querySelector("[data-bulk-popup]");
  const rowsEl = popup?.querySelector("[data-bulk-rows]");
  const closeBtn = popup?.querySelector("[data-bulk-close]");
  const inner = popup?.querySelector(".vp-bulkpop__inner");

  if (!popup || !rowsEl || !inner) return;

  let lastTrigger = null;

  // IMPORTANT:
  // We will read prices via trigger.getAttribute(`data-${key}`)
  // so hyphenated keys like tier-100-plus work reliably on all browsers.
  const tiers = [
    { key: "tier-1-11", label: "1–11" },
    { key: "tier-12-23", label: "12–23" },
    { key: "tier-24-47", label: "24–47" },
    { key: "tier-48-99", label: "48–99" },
    { key: "tier-100-plus", label: "100+" }
  ];

  const formatMoney = (value) => {
    if (value === null || value === undefined) return null;
    const v = String(value).trim();
    if (v === "") return null;

    const num = Number(v);
    if (!Number.isFinite(num)) return null;

    return `$${num.toFixed(2)}`;
  };

  const buildRows = (trigger) => {
    rowsEl.innerHTML = "";
    let hasAny = false;

    tiers.forEach((tier) => {
      // Read raw data attribute directly (reliable on desktop + mobile)
      const raw = trigger.getAttribute(`data-${tier.key}`);
      const price = formatMoney(raw);
      if (!price) return;

      hasAny = true;
      const row = document.createElement("div");
      row.className = "vp-bulkrow";
      row.innerHTML = `<span>${tier.label}</span><span>${price} / ea</span>`;
      rowsEl.appendChild(row);
    });

    if (!hasAny) {
      rowsEl.innerHTML =
        `<div class="vp-bulkrow"><span>No bulk pricing set</span><span></span></div>`;
    }
  };

  const positionPopup = (trigger) => {
    if (!trigger) return;

    const rect = trigger.getBoundingClientRect();
    const gap = 10;

    const width = inner.offsetWidth;
    const height = inner.offsetHeight;

    let left = rect.left + rect.width / 2 - width / 2;
    left = Math.max(12, Math.min(left, window.innerWidth - width - 12));

    let top = rect.top - height - gap;
    if (top < 12) top = rect.bottom + gap;

    // Popup overlay is fixed, so this is viewport positioning (no scrollY)
    inner.style.left = `${left}px`;
    inner.style.top = `${top}px`;
  };

  const openPopup = (trigger) => {
    lastTrigger = trigger;
    buildRows(trigger);

    popup.hidden = false;
    trigger.setAttribute("aria-expanded", "true");

    requestAnimationFrame(() => {
      positionPopup(trigger);
    });
  };

  const closePopup = () => {
    popup.hidden = true;

    if (lastTrigger) {
      lastTrigger.setAttribute("aria-expanded", "false");
      lastTrigger = null;
    }
  };

  const togglePopup = (trigger) => {
    if (!popup.hidden && lastTrigger === trigger) closePopup();
    else openPopup(trigger);
  };

  // --- Events ---

  // pointerdown is more reliable for mobile taps than click
  document.addEventListener("pointerdown", (event) => {
    // Close button
    if (event.target.closest("[data-bulk-close]")) {
      event.preventDefault();
      event.stopPropagation();
      closePopup();
      return;
    }

    // Trigger button
    const trigger = event.target.closest("[data-bulk-trigger]");
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      togglePopup(trigger);
      return;
    }

    // Outside click closes
    if (!popup.hidden && !inner.contains(event.target)) {
      closePopup();
    }
  });

  // Backup close handler (some browsers fire click but not pointerdown in edge cases)
  if (closeBtn) {
    closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      closePopup();
    });
  }

  // Reposition while open
  window.addEventListener(
    "scroll",
    () => {
      if (!popup.hidden && lastTrigger) positionPopup(lastTrigger);
    },
    { passive: true }
  );

  window.addEventListener("resize", () => {
    if (!popup.hidden && lastTrigger) positionPopup(lastTrigger);
  });

  // Escape closes on desktop
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !popup.hidden) closePopup();
  });

  // Prevent inside interactions from bubbling and closing the popup
  inner.addEventListener("pointerdown", (e) => e.stopPropagation());
})();
